import { is_weixin } from "@/assets/js/common.js";
import wx from "weixin-js-sdk";
var i = 0; //上传序号

export default {
  // 微信调取相册方法
  getAlbum: function(obj, calback) {
    if (is_weixin()) {
      obj.$http.get(
        "/wechat/oauth2/getJSSDKConfig?url=" +
          encodeURIComponent(location.href.split("#")[0]),
        {},
        (res) => {
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              "checkJsApi",
              "chooseImage", //调取微信相册接口
              "getLocalImgData",
              "uploadImage",
            ],
            openTagList: ["wx-open-launch-weapp"]
          });
          wx.ready(function() {
            // 微信分享的数据
            wx.checkJsApi({
              jsApiList: ["chooseImage"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
              success: function(res) {
                console.log(res);
                // 以键值对的形式返回，可用的api值true，不可用为false
                // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
              },
            });
            setTimeout(function() {
              wx.chooseImage({
                count: 1, // 默认9
                sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
                sourceType: ["album"], // 可以指定来源是相册还是相机，默认二者都有
                success: function(res) {
                  i=0;
                  var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                  wx.uploadImage({
                    localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
                    isShowProgressTips: 1, // 默认为1，显示进度提示
                    success: function(result) {
                      let serverId = result.serverId; // 返回图片的服务器端ID
                      if (result.errMsg === "uploadImage:ok") {
                        calback([serverId, localIds]);
                      }
                      // wx.downloadImage({
                      //     serverId: serverId, // 需要上传的图片的本地ID，由chooseImage接口获得
                      //     isShowProgressTips: 1, // 默认为1，显示进度提示
                      //     success: function (result) {
                      //         let localId = result.localId; // 返回图片的服务器端ID
                      //         alert(localId)
                      //         // 可以将serverId传给后台，用于存放在自己服务器上
                      //     }
                      // }) // 可以将serverId传给后台，用于存放在自己服务器上
                    },
                    complete: function(result) {},
                    fail: function(res) {
                      calback("err");
                    },
                  });
                },
                fail: function(res) {
                  obj.$toast({
                    duration: 2000,
                    forbidClick: true,
                    message: "网络繁忙，请稍后重试！",
                    context: this,
                  });
                  calback("err");
                },
              });
            }, 1000);
          });
        }
      );
    }
  },
  // 微信调取相册多张图片
  getMoreAlbum: function(obj,count,calback) {
    var that = this;
    if (is_weixin()) {
      obj.$http.get(
        "/wechat/oauth2/getJSSDKConfig?url=" +
          encodeURIComponent(location.href.split("#")[0]),
        {},
        (res) => {
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              "checkJsApi",
              "chooseImage", //调取微信相册接口
              "getLocalImgData",
              "uploadImage",
            ],
            openTagList: ["wx-open-launch-weapp"]
          });
          wx.ready(function() {
            // 微信分享的数据
            wx.checkJsApi({
              jsApiList: ["chooseImage"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
              success: function(res) {
                console.log(res);
                // 以键值对的形式返回，可用的api值true，不可用为false
                // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
              },
            });
              setTimeout(function(){
              wx.chooseImage({
              count: count, // 默认9
              sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
              sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
              success: function(res) {
                i = 0;
                var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                that.uploadImg(localIds, calback);
              },
              fail: function(res) {
                obj.$toast({
                  duration: 2000,
                  forbidClick: true,
                  message: "网络繁忙，请稍后重试！",
                  context: this,
                });
                // calback("err");
              },
            });
              },500)
          });
        }
      );
    }
  },
//  上传图片
  uploadImg(data, calback) {
    var that = this;
    var len = data.length;
    wx.uploadImage({
      localId: data[i].toString(), // 需要上传的图片的本地ID，由chooseImage接口获得
      isShowProgressTips: 1, // 默认为1，显示进度提示
      success: function(result) {
        i++;
        let serverId = result.serverId; // 返回图片的服务器端ID
        if (result.errMsg === "uploadImage:ok") {
          calback([serverId, data]);
        }
        //递归上传
        if (i < len) {
          that.uploadImg(data, calback);
        }
      },
      complete: function(result) {},
      fail: function(res) {
        console.log(res)
        that.$toast({
          duration: 2000,
          forbidClick: true,
          message: "上传失败",
          context: this,
        });

      },
    });
  },
};
